export default __webpack_public_path__ + "static/media/measures.d9243677.svg";